import React, { useState, useCallback } from 'react'

import isEmpty from 'lodash/isEmpty'
import TextWrapper from './TextWrapper'
import PopOver from './PopOver'
import { Col, Button, Row } from 'reactstrap'
import { getFrench } from './FrenchTranslation'
import FormModal from './EventForm'
import { makeDeleteRequest } from 'utils/api'
import { Avatar, Box, Stack, Tooltip } from '@mui/material'
import { useSelector } from 'react-redux'
import moment from 'moment'

const renderEventDetailsRow = (label, value = '') => {
  return (
    !isEmpty(value) && (
      <>
        {label === 'Participant' ? (
          <Col xs={12} className="px-0">
            <div className={`mx-0`}>
              <div>
                <TextWrapper className={`font-size-inherit popover-label`}>{label}:</TextWrapper>
              </div>
              <Box>
                <Stack direction="row" spacing={2}>
                  {value &&
                    value.map((v) => (
                      <Tooltip key={v.id} title={v.NomPreNom}>
                        <Avatar key={v.id} alt={v.NomPreNom} src={v.Picture} />
                      </Tooltip>
                    ))}
                </Stack>
              </Box>
            </div>
          </Col>
        ) : (
          <Col xs={12} className="px-0">
            <div className={`mx-0`}>
              <div>
                <TextWrapper className={`font-size-inherit popover-label`}>{label}:</TextWrapper>
              </div>
              <div>{value}</div>
            </div>
          </Col>
        )}
      </>
    )
  )
}

const EventPopOverCard = ({
  item: {
    type,
    category,
    title = 'Event',
    code,
    start,
    end,
    location,
    isAllDay,
    eventType,
    region,
    designation,
    pays,
    participants,
    participants_list,
  },
  id,
  event_id,
  textClassName,
  isOpen,
  getAllEvents = false,
}) => {
  const siteUser = useSelector((store) => store.user)
  let time_formate = siteUser.user?.user_parameter?.format_de_lheure

  const [showModal, setShowModal] = useState(false)
  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  })

  const de = `${start.getDate()} ${getFrench(start.getMonth() + 1)} ${start.getFullYear()} ${moment(
    start.toLocaleTimeString('en-US'),
    'hh:mm:ss a',
  ).format(time_formate === '24h' ? 'HH:mm:ss' : 'hh:mm:ss A')}`
  const a = `${end.getDate()} ${getFrench(end.getMonth() + 1)} ${end.getFullYear()} ${moment(
    end.toLocaleTimeString('en-US'),
    'hh:mm:ss a',
  ).format(time_formate === '24h' ? 'HH:mm:ss' : 'hh:mm:ss A')}`
  return (
    <>
      <PopOver
        id={`${id}-${start.getDate()}-${end.getDate()}`}
        eid={`${event_id}`}
        text={eventType === 'f' ? designation || title : title}
        textClassName={textClassName}
        showLink={false}
        showModal={showModal}
        content={title}
        isOpen={isOpen}
      >
        {eventType === 'a' && (
          <>
            {renderEventDetailsRow('Lieux', location)}
            {renderEventDetailsRow('de', de)}
            {renderEventDetailsRow('a', a)}
            <input type={'checkbox'} checked={isAllDay} readOnly={true} />
            <span> Journee entière</span>
            {participants_list &&
              participants_list.length > 0 &&
              renderEventDetailsRow('Participant', participants_list)}
            {/* {renderEventDetailsRow('Participant', participants)} */}
            {renderEventDetailsRow('Categorie', category)}
            {renderEventDetailsRow('Type', type)}

            <Button
              style={{ backgroundColor: '#5D86CC' }}
              size="sm"
              onClick={() => setShowModal(true)}
            >
              {getFrench('edit')}
            </Button>
            <Button
              color="danger"
              size="sm"
              onClick={() => {
                makeDeleteRequest(`/api/time/events/${event_id}`, {}, true).then(() => {
                  // window.location.reload()
                  if (getAllEvents) {
                    getAllEvents()
                  }
                })
              }}
            >
              {getFrench('delete')}
            </Button>
          </>
        )}
        {eventType === 'f' && (
          <>
            {renderEventDetailsRow('Region', region)}
            {renderEventDetailsRow('Pays', pays)}
            {renderEventDetailsRow('Designation', designation)}
          </>
        )}
      </PopOver>
      {showModal && (
        <FormModal
          isOpen={showModal}
          getAllEvents={getAllEvents}
          toggleModal={toggleModal}
          title={'Rendez-vous'}
          editMode={true}
          eventId={event_id}
        />
      )}
    </>
  )
}

export default EventPopOverCard
